module.exports = __webpack_public_path__ + "img/road-d.fdebf39c.png";